export default "__VITE_ASSET__53cf20a4__"